import React from 'react';
import { Stack } from 'expo-router';
import { Platform } from 'react-native';

export default function PublicLayout() {
    return (
        <Stack
            screenOptions={{
                headerShown: false,
                ...(Platform.OS === 'web' ? { animation: 'none' } : {}),
            }}
        />
    );
}
